/* eslint-disable no-param-reassign */
import { api } from "jiffy-api";
import { MODES } from "../misc/constants";
import { prefillVariantInputs } from "../utils/qty-grid";

const getDefaultMode = () => document.getElementById("order-number-container")?.dataset?.pageMode;

const MADE_MODES = {
  PRINT_DEFAULT: "print_default",
  PRINT_FRONT_BACK: "print_front_back"
};

const initialState = {
  mode: getDefaultMode() || MODES.BLANKS,
  supportsMade: false,
  isRestoring: false,
  filledSizes: [],
  madeMode: MADE_MODES.PRINT_DEFAULT,
  activeColor: "",
  compositionId: null
};

const appModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    mode: state => state.mode,
    madeMode: state => state.madeMode,
    activeColor: state => state.activeColor,
    supportsMade: state => state.supportsMade,
    filledSizes: state => state.filledSizes,
    isRestoring: state => state.isRestoring
  },

  mutations: {
    setMode(state, mode) {
      state.mode = mode;
    },
    setMadeMode(state, madeMode) {
      state.madeMode = madeMode;
    },
    setSupportsMade(state, supportsMade) {
      state.supportsMade = supportsMade;
    },
    setActiveColor(state, color) {
      state.activeColor = color;
    },
    setFilledSizes(state, sizes) {
      state.filledSizes = sizes;
    },
    setIsRestoring(state, isRestoring) {
      state.isRestoring = isRestoring;
    }
  },

  actions: {
    setMode({ commit }, mode) {
      commit("setMode", mode);
    },
    setActiveComposition({ commit }, { compositionId, color }) {
      commit("setActiveColor", color);

      const numId = Number(compositionId);
      if (Number.isNaN(numId)) throw new Error(`Invalid compositionId: ${compositionId}`);
      commit("product/setCompositionId", numId, { root: true });
    },
    async restore({ commit, rootGetters, dispatch }, { asgid }) {
      commit("setIsRestoring", true);

      const requests = [api.printOnDemand.getMadeOrder({ asgid })];

      if (!rootGetters["product/currentProduct"]) {
        requests.push(dispatch("product/fetchProduct", {}, { root: true }));
      }

      const [response] = await Promise.all(requests);

      Object.keys(response.placements).forEach(placement => {
        const details = response.placements[placement];
        const variant = placement.includes("front") ? "front" : "back";

        dispatch(`artwork_${variant}/setDataFromPreset`, details, { root: true });
        commit(
          `surface_${variant}/setDataFromPreset`,
          { ...details, positionId: details.id },
          { root: true }
        );
      });

      prefillVariantInputs(response.variants);

      commit("setIsRestoring", false);
    }
  }
};

export default appModule;
